(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("fxdv5", function(module, exports) {

var $80wRE = parcelRequire("80wRE");
let $b4f468f72dc0095d$var$map;
const $b4f468f72dc0095d$var$gMarkers = [];
const $b4f468f72dc0095d$var$mapElement = document.getElementById("branch-info-map");
const $b4f468f72dc0095d$var$mapLat = $b4f468f72dc0095d$var$mapElement?.dataset.lat;
const $b4f468f72dc0095d$var$mapLng = $b4f468f72dc0095d$var$mapElement?.dataset.lng;
const $b4f468f72dc0095d$var$icon = $b4f468f72dc0095d$var$mapElement?.dataset.icon ?? null;
const $b4f468f72dc0095d$var$mapSettings = JSON.parse($b4f468f72dc0095d$var$mapElement?.getAttribute("data-map") ?? "");
const $b4f468f72dc0095d$var$initMap = async ()=>{
    if ($b4f468f72dc0095d$var$mapElement && $b4f468f72dc0095d$var$mapLat && $b4f468f72dc0095d$var$mapLng) {
        const google = await (0, $80wRE.default)();
        const { AdvancedMarkerElement: AdvancedMarkerElement } = await google.maps.importLibrary("marker");
        $b4f468f72dc0095d$var$map = new google.maps.Map($b4f468f72dc0095d$var$mapElement, {
            mapId: $b4f468f72dc0095d$var$mapSettings.map_id,
            center: {
                lat: Number($b4f468f72dc0095d$var$mapLat),
                lng: Number($b4f468f72dc0095d$var$mapLng)
            },
            zoom: 17
        });
        const marker = new AdvancedMarkerElement({
            map: $b4f468f72dc0095d$var$map,
            position: {
                lat: Number($b4f468f72dc0095d$var$mapLat),
                lng: Number($b4f468f72dc0095d$var$mapLng)
            },
            content: $b4f468f72dc0095d$var$icon ? $b4f468f72dc0095d$var$setIcon($b4f468f72dc0095d$var$icon) : null
        });
        $b4f468f72dc0095d$var$gMarkers.push(marker);
    }
};
$b4f468f72dc0095d$var$initMap();
const $b4f468f72dc0095d$var$setIcon = (iconSrc)=>{
    const markerSvg = document.createElement("img");
    markerSvg.src = iconSrc;
    return markerSvg;
};

});
parcelRegister("80wRE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d47d0fe846d6826$export$2e2bcd8739ae039; });

var $f1Q1B = parcelRequire("f1Q1B");
const $5d47d0fe846d6826$var$options = {};
const $5d47d0fe846d6826$var$mapElements = document.querySelectorAll('.js-google-map');
let $5d47d0fe846d6826$var$apiKey = "";
$5d47d0fe846d6826$var$mapElements.forEach((element)=>{
    if (element.dataset.apiKey) $5d47d0fe846d6826$var$apiKey = element.dataset.apiKey;
});
const $5d47d0fe846d6826$var$loader = new (0, $f1Q1B.Loader)($5d47d0fe846d6826$var$apiKey, $5d47d0fe846d6826$var$options);
const $5d47d0fe846d6826$var$loadGoogleMaps = async ()=>{
    if (window.google && window.google.maps) {
        console.log("Google Maps API is already loaded.");
        return window.google;
    }
    console.log("Loading Google Maps API...");
    return await $5d47d0fe846d6826$var$loader.load();
};
var $5d47d0fe846d6826$export$2e2bcd8739ae039 = $5d47d0fe846d6826$var$loadGoogleMaps;

});
parcelRegister("f1Q1B", function(module, exports) {

$parcel$export(module.exports, "Loader", function () { return $af0f4e0e8dc84ba6$export$3b0d6d7590275603; });
class $af0f4e0e8dc84ba6$export$3b0d6d7590275603 {
    constructor(apiKey = null, options = {}){
        this.apiKey = apiKey;
        this.options = options;
        if (typeof window === 'undefined') throw new Error('google-maps is supported only in browser environment');
    }
    load() {
        if (typeof this.api !== 'undefined') return Promise.resolve(this.api);
        if (typeof this.loader !== 'undefined') return this.loader;
        window[$af0f4e0e8dc84ba6$export$3b0d6d7590275603.CALLBACK_NAME] = ()=>{
            this.api = window['google'];
            if (typeof this.resolve === 'undefined') throw new Error('Should not happen');
            this.resolve(this.api);
        };
        window['gm_authFailure'] = ()=>{
            if (typeof this.reject === 'undefined') throw new Error('Should not happen');
            this.reject(new Error('google-maps: authentication error'));
        };
        return this.loader = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
            const script = document.createElement('script');
            script.src = this.createUrl();
            script.async = true;
            script.onerror = (e)=>reject(e);
            document.head.appendChild(script);
        });
    }
    createUrl() {
        const parameters = [
            `callback=${$af0f4e0e8dc84ba6$export$3b0d6d7590275603.CALLBACK_NAME}`
        ];
        if (this.apiKey) parameters.push(`key=${this.apiKey}`);
        for(let name in this.options)if (this.options.hasOwnProperty(name)) {
            let value = this.options[name];
            if (name === 'version') name = 'v';
            if (name === 'libraries') value = value.join(',');
            parameters.push(`${name}=${value}`);
        }
        return `https://maps.googleapis.com/maps/api/js?${parameters.join('&')}`;
    }
}
$af0f4e0e8dc84ba6$export$3b0d6d7590275603.CALLBACK_NAME = '_dk_google_maps_loader_cb';

});



})();
//# sourceMappingURL=branch-info-section--map.909ad84f.js.map
